import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EScolaMaterial } from 'src/app/domain/enums/scola-material';
import { MPCA } from 'src/app/domain/mpca';

import { StringTool } from '../../mapping/string.tool';
import { StringConverter } from '../string-converter';
import { EDegradationLevel } from 'src/app/domain/enums/degradation-level';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-mpca-box',
    templateUrl: 'add-mpca-box.html',
    styleUrls: ['./add-mpca-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AddMPCABoxDialog implements OnInit {

    Model: MPCA = new MPCA();
    public ScolaMaterialList: string[] = Object.values(EScolaMaterial)
        .filter(x => isNaN(Number(x)))
        .map((x: any) => x);
    public DegradationLevelList: string[] = Object.values(EDegradationLevel)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getDegradationLevelName(x));

    constructor(
        public dialogRef: MatDialogRef<AddMPCABoxDialog>) {

    }

    ngOnInit() {
    }

    canFinish() {
        return StringTool.isNotNullOrEmpty(this.Model.Name) && this.Model.ScolaMaterial && this.Model.DegradationLevel;
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {
        if (!this.canFinish()) {
            return;
        }
        this.dialogRef.close(this.Model);
    }
}
